import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { getLanguageObj, settings } from '../helpers/main.js';

import PublicRouter from './PublicRouter.js';
import PrivateRouter from './PrivateRouter.js';

import Login from '../views/auth/Login.js';
import PasswordRecoverChangePassword from '../views/auth/PasswordRecoverChangePassword.js';
import PasswordRecover from '../views/auth/PasswordRecover.js';
import RequestAccount from '../views/auth/RequestAccount.js';
import RequestAccountDetails from '../views/auth/RequestAccountDetails.js';
import RequestAccountMonitor from '../views/auth/RequestAccountMonitor.js';

import Home from '../views/home/Home.js';
// import About from '../views/home/About.js';
// import Contact from '../views/home/Contact.js';
// import Privacy from '../views/home/Privacy.js';

import NotFound from '../views/home/NotFound.js';
import Footer from '../views/main/Footer.js';
import Header from '../views/main/Header.js';
import { useState } from 'react';

import Countries from '../views/countries/Countries.js';
import Companies from '../views/companies/Companies.js';
import Customers from '../views/customers/Customers.js';
import StatusView from '../views/status/Status.js';
import Types from '../views/types/Types.js';
import Users from '../views/users/Users.js';
import UserEditDetails from '../views/users/UserEditDetails.js';
import UserCompanyCustomersEditDetails from '../views/users/UserCompanyCustomersEditDetails.js';
import Analysts from '../views/analysts/Analysts.js';
import Devices from '../views/devices/Devices.js';
import Configurations from '../views/configurations/Configurations.js';
import Toasts from '../views/notifications/toasts/Toasts.js';
import ToastAdd from '../views/notifications/toasts/ToastAdd.js';
import ToastEditDetails from '../views/notifications/toasts/ToastEditDetails.js';

import Sales from '../views/purchases/Sales.js';
import SaleUserCompanyCustomers from '../views/purchases/SaleUserCompanyCustomers.js';
import SaleDetailStatementAccounts from '../views/purchases/SaleDetailStatementAccounts.js';
import SaleDetailDocuments from '../views/purchases/SaleDetailDocuments.js';

import PaymentInformations from '../views/paymentInformations/PaymentInformations.js';
import PaymentInformationEditDetails from '../views/paymentInformations/PaymentInformationEditDetails.js';

import Requirements from '../views/requirements/Requirements.js';
import RequirementEdit from '../views/requirements/RequirementEdit.js';

import BackupReviews from '../views/backupReviews/BackupReviews.js';
import BackupReviewEdit from '../views/backupReviews/BackupReviewEdit.js';

import DataCenters from '../views/dataCenters/DataCenters.js';
import DataCenterEdit from '../views/dataCenters/DataCenterEdit.js';

import Parameters from '../views/parameters/Parameters.js';
import ParameterDetailsEdit from '../views/parameters/ParameterDetailsEdit.js';

import DomainHostings from '../views/domainHostings/DomainHostings.js';
import DomainHostingEdit from '../views/domainHostings/DomainHostingEdit.js';

import RemoteConnections from '../views/remoteConnections/RemoteConnections.js';
import RemoteConnectionEdit from '../views/remoteConnections/RemoteConnectionEdit.js';

import Profile from '../views/profile/Profile.js';

import SystemAccesses from '../views/systemAccesses/SystemAccesses.js';
import SystemAccessAddEditDetails from '../views/systemAccesses/SystemAccessAddEditDetails.js';

import { GlobalFormats } from '../classess/main/globalFormats.js';

export default function AppRoter() {
    //#region variables
    const currentMethod = 'AppRouter';
    const location = window.location;
    const hideSection = {
        header: false,
        footer: false,
    };
    const [languageObj] = useState(GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result));
    //#region old code
    // const hideSections = [
    //     settings?.backend?.urls?.forgotPassword,
    //     settings?.backend?.urls?.login,
    //     settings?.backend?.urls?.register,
    // ];
    //#endregion old code
    const hideSections = [];
    //#endregion variables

    //#region process
    for (const section of hideSections) {
        if (location.pathname.includes(section)) {
            hideSection.footer = true;
            hideSection.header = true;
            break;
        }
    }
    //#endregion process

    return (
        <Router>
            {/* Preloader */}
            <div className='preloader flex-column justify-content-center align-items-center'>
                <img className={settings.html.animations.onLoad.shake} src={settings?.images?.appLogo} alt='appLogo' height={80} width='auto' />
            </div>

            {/* {hideSection.header ? <div></div> : <Header languageObj={languageObj} />} */}
            {hideSection.header ? <div></div> : <Header />}
            <Switch>
                {/*Home*/}
                {/* <Route exact path='/' element={<Home languageObj={languageObj} />} />
                <Route exact path='/home' element={<Home languageObj={languageObj} />} /> */}

                {/* <Route exact path={settings?.backend?.urls?.about} element={<About />} /> */}
                {/* <Route exact path={settings?.backend?.urls?.contact} element={<Contact />} /> */}
                {/* <Route exact path={settings?.backend?.urls?.privacy} element={<Privacy />} /> */}
                {/* <Route exact path={settings?.backend?.urls?.about} component={About} /> */}
                {/* <Route exact path={settings?.backend?.urls?.contact} component={Contact} /> */}
                {/* <Route exact path={settings?.backend?.urls?.privacy} component={Privacy} /> */}
                <Route exact path='/' component={Home} />
                <Route exact path='/home' component={Home} />

                {/* Authentication */}
                {/* <Route exact
                    path={settings?.backend?.urls?.login}
                    element={!auth?.isLoged({ subMethod: currentMethod })?.result ?
                        <Login languageObj={languageObj} /> :
                        <Navigate replace to='/' />} />
                <Route exact
                    path={settings?.backend?.urls?.recoverPassword}
                    element={!auth?.isLoged({ subMethod: currentMethod })?.result ?
                        <PasswordRecover languageObj={languageObj} /> :
                        <Navigate replace to='/' />} />
                <Route exact
                    path={settings?.backend?.urls?.requestAccount}
                    element={!auth?.isLoged({ subMethod: currentMethod })?.result ?
                        <RequestAccount languageObj={languageObj} /> :
                        <Navigate replace to='/' />} />
                <Route exact
                    path={settings?.backend?.urls?.requestAccountMonitor}
                    element={!auth?.isLoged({ subMethod: currentMethod })?.result ?
                        <RequestAccountMonitor languageObj={languageObj} /> :
                        <Navigate replace to='/' />} />
                <Route path={`${settings?.backend?.urls?.recoverPassword}/:id`}
                    element={!auth?.isLoged({ subMethod: currentMethod })?.result ?
                        <PasswordRecoverChangePassword languageObj={languageObj} /> :
                        <Navigate replace to='/' />} />
                <Route path={`${settings?.backend?.urls?.requestAccountDetails}/:id/:isNew`}
                    element={!auth?.isLoged({ subMethod: currentMethod })?.result ?
                        <RequestAccountDetails languageObj={languageObj} /> :
                        <Navigate replace to='/' />} /> */}
                <PublicRouter exact path={settings?.backend?.urls?.login} component={Login} />
                <PublicRouter exact path={settings?.backend?.urls?.recoverPassword} component={PasswordRecover} />
                <PublicRouter exact path={settings?.backend?.urls?.requestAccount} component={RequestAccount} />
                <PublicRouter exact path={settings?.backend?.urls?.requestAccountMonitor} component={RequestAccountMonitor} />

                <PublicRouter exact path={`${settings?.backend?.urls?.recoverPassword}/:id`} component={PasswordRecoverChangePassword} />
                <PublicRouter exact path={`${settings?.backend?.urls?.requestAccountDetails}/:id/:isNew`} component={RequestAccountDetails} />

                {/* Countries */}
                {/* <Route exact
                    path={settings?.backend?.urls?.countries}
                    element={auth?.isLoged({ subMethod: currentMethod })?.result ?
                        <Countries languageObj={languageObj} /> :
                        <Navigate replace to={settings?.backend?.urls?.login} state={{ from: settings?.backend?.urls?.countries }} />} />*/}
                <PrivateRouter exact path={settings?.backend?.urls?.countries} component={Countries} />
                <PrivateRouter exact path={settings?.backend?.urls?.companies} component={Companies} />
                <PrivateRouter exact path={settings?.backend?.urls?.customers} component={Customers} />
                <PrivateRouter exact path={settings?.backend?.urls?.status} component={StatusView} />
                <PrivateRouter exact path={settings?.backend?.urls?.types} component={Types} />
                <PrivateRouter exact path={settings?.backend?.urls?.users} component={Users} />
                <PrivateRouter path={`${settings?.backend?.urls?.users}/:id`} component={UserEditDetails} />
                <PrivateRouter path={`${settings?.backend?.urls?.userCompanyCustomers}/:id`} component={UserCompanyCustomersEditDetails} />
                <PrivateRouter exact path={settings?.backend?.urls?.analysts} component={Analysts} />
                <PrivateRouter exact path={settings?.backend?.urls?.devices} component={Devices} />
                <PrivateRouter exact path={settings?.backend?.urls?.configurations} component={Configurations} />
                <PrivateRouter exact path={`${settings?.backend?.urls?.notifications}${settings?.backend?.urls?.toasts}`} component={Toasts} />
                <PrivateRouter exact path={`${settings?.backend?.urls?.notifications}${settings?.backend?.urls?.toasts}/${settings?.backend?.methods?.notifications?.toasts?.create}`} component={ToastAdd} />
                <PrivateRouter path={`${settings?.backend?.urls?.notifications}${settings?.backend?.urls?.toasts}/:id`} component={ToastEditDetails} />

                {/*Sales (bill to pay*/}
                <PrivateRouter exact path={`${settings?.backend?.urls?.sales}`} component={Sales} />
                <PrivateRouter path={`${settings?.backend?.urls?.sales}${settings?.backend?.urls?.saleUserCompanyCustomers}/:id`} component={SaleUserCompanyCustomers} />
                <PrivateRouter path={`${settings?.backend?.urls?.sales}${settings?.backend?.urls?.saleDetailStatementAccounts}/:id/:customerId`} component={SaleDetailStatementAccounts} />
                <PrivateRouter path={`${settings?.backend?.urls?.sales}${settings?.backend?.urls?.saleDetailDocuments}/:id/:customerId/:docType/:docNumber`} component={SaleDetailDocuments} />

                {/*Payment informations*/}
                <PrivateRouter exact path={`${settings?.backend?.urls?.paymentInformations}`} component={PaymentInformations} />
                <PrivateRouter path={`${settings?.backend?.urls?.paymentInformations}/:type/:id`} component={PaymentInformationEditDetails} />

                {/*Requirements*/}
                <PrivateRouter exact path={`${settings?.backend?.urls?.requirements}`} component={Requirements} />
                <PrivateRouter path={`${settings?.backend?.urls?.requirements}/:type/:id`} component={RequirementEdit} />

                {/*BackupReviews*/}
                <PrivateRouter exact path={`${settings?.backend?.urls?.backupReviews}`} component={BackupReviews} />
                <PrivateRouter path={`${settings?.backend?.urls?.backupReviews}/:type/:id`} component={BackupReviewEdit} />

                {/*DataCenters*/}
                <PrivateRouter exact path={`${settings?.backend?.urls?.dataCenters}`} component={DataCenters} />
                <PrivateRouter path={`${settings?.backend?.urls?.dataCenters}/:type/:id`} component={DataCenterEdit} />

                {/*Parameters*/}
                <PrivateRouter exact path={`${settings?.backend?.urls?.parameters}`} component={Parameters} />
                <PrivateRouter path={`${settings?.backend?.urls?.parameters}/:type/:id`} component={ParameterDetailsEdit} />

                {/*DomainHostings*/}
                <PrivateRouter exact path={`${settings?.backend?.urls?.domainHostings}`} component={DomainHostings} />
                <PrivateRouter path={`${settings?.backend?.urls?.domainHostings}/:type/:id`} component={DomainHostingEdit} />

                {/*RemoteConnections*/}
                <PrivateRouter exact path={`${settings?.backend?.urls?.remoteConnections}`} component={RemoteConnections} />
                <PrivateRouter path={`${settings?.backend?.urls?.remoteConnections}/:type/:id`} component={RemoteConnectionEdit} />

                {/*Profile*/}
                <PrivateRouter exact path={`${settings?.backend?.urls?.profile}`} component={Profile} />

                {/*SystemAccess*/}
                <PrivateRouter exact path={`${settings?.backend?.urls?.systemAccesses}`} component={SystemAccesses} />
                {/* <PrivateRouter exact path={`${settings?.backend?.urls?.systemAccesses}/${settings?.labels?.create?.['en']?.trim()?.toLowerCase()}`} component={SystemAccessAddEdit} /> */}
                <PrivateRouter path={`${settings?.backend?.urls?.systemAccesses}/:type/:id`} component={SystemAccessAddEditDetails} />

                {/* <Route path='*' element={<NotFound languageObj={languageObj} />} /> */}
                <Route path='*' component={NotFound} />
            </Switch>
            {hideSection.footer ? <div></div> : <Footer languageObj={languageObj} />}
        </Router>
    );
}